import { render } from "./PagesCard.vue?vue&type=template&id=6e7acc55"
import script from "./PagesCard.vue?vue&type=script&lang=js"
export * from "./PagesCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__